import { BaseEntity } from "#sitis/internal/models/concrete/BaseEntity";
export class Category extends BaseEntity {
  name;
  nameOne;
  title;
  description;
  text;
  shortDescription;
  depth;
  unit;
  countStep;
  showInMenu;
  data;
  productPriceFrom;
  activeProductsCount;
  slug;
  image;
  imageId;
  metaTitle;
  metaDescription;
  metaKeywords;
  parentId;
  file;
  images;
  imagesIds;
  url;
  featuredFilterPages;
  productsUpdatedAt;
  updatedAt;
  dynamicFields;
  items;
  constructor(data) {
    super(data);
    this.activeProductsCount = data.active_products_count;
    this.countStep = data.count_step;
    this.data = data.data;
    this.depth = data.depth;
    this.description = data.description;
    this.text = data.text;
    this.file = data.file;
    this.image = data.image;
    this.imageId = data.image_id;
    this.imagesIds = data.images_ids;
    this.metaDescription = data.meta_description;
    this.metaKeywords = data.meta_keywords;
    this.metaTitle = data.meta_title;
    this.name = data.name;
    this.nameOne = data.name_one;
    this.parentId = data.parent_id;
    this.productPriceFrom = data.product_price_from;
    this.shortDescription = data.short_description;
    this.showInMenu = data.show_in_menu;
    this.slug = data.slug;
    this.title = data.title;
    this.unit = data.unit;
    this.url = data.url;
    this.featuredFilterPages = data.featuredFilterPages;
    this.productsUpdatedAt = data.products_updated_at;
    this.updatedAt = data.updated_at;
    this.items = data.items;
    const dynamicFields = { ...data };
    [
      "active_products_count",
      "count_step",
      "data",
      "depth",
      "description",
      "text",
      "file",
      "image",
      "image_id",
      "images_ids",
      "meta_description",
      "meta_keywords",
      "meta_title",
      "name",
      "name_one",
      "parent_id",
      "product_price_from",
      "short_description",
      "show_in_menu",
      "slug",
      "title",
      "unit",
      "url",
      "featuredFilterPages",
      "products_updated_at",
      "updated_at"
    ].forEach((key) => {
      delete dynamicFields[key];
    });
    this.dynamicFields = dynamicFields;
  }
  toJSON() {
    return { ...this };
  }
}
